var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 31.1666C24.8242 31.1666 31.1668 24.824 31.1668 16.9999C31.1668 9.17588 24.8242 2.83325 17.0002 2.83325C9.17613 2.83325 2.8335 9.17588 2.8335 16.9999C2.8335 24.824 9.17613 31.1666 17.0002 31.1666Z",
    stroke: "#667085",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8565 11.71C21.5486 11.4793 21.8946 11.364 22.1248 11.446C22.325 11.5175 22.4826 11.675 22.554 11.8753C22.6361 12.1054 22.5207 12.4515 22.29 13.1436L20.1827 19.4657C20.117 19.6628 20.0841 19.7613 20.0281 19.8432C19.9786 19.9157 19.9159 19.9783 19.8434 20.0279C19.7616 20.0839 19.663 20.1167 19.4659 20.1824L13.1438 22.2898C12.4517 22.5205 12.1057 22.6359 11.8756 22.5538C11.6753 22.4824 11.5177 22.3248 11.4463 22.1245C11.3642 21.8944 11.4796 21.5483 11.7103 20.8562L13.8176 14.5342C13.8833 14.3371 13.9162 14.2385 13.9722 14.1567C14.0218 14.0842 14.0844 14.0215 14.1569 13.9719C14.2387 13.9159 14.3373 13.8831 14.5344 13.8174L20.8565 11.71Z",
    stroke: "#667085",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.ca2d82907034bc846a55f03f502e911b.svg";
export { ForwardRef as ReactComponent };